import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "press inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-semibold tracking-[-0.005em] transition-[transform,background-color,border-color,box-shadow,color] duration-200 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "btn-plum",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline:
          "border border-white/10 bg-white/[0.02] hover:border-[hsl(var(--gold)/0.5)] hover:bg-accent/40 hover:text-foreground",
        secondary:
          "bg-secondary text-secondary-foreground border border-border/60 hover:border-[hsl(var(--gold)/0.35)]",
        gold:
          "bg-[hsl(var(--gold))] text-[hsl(240_9%_6%)] font-semibold shadow-[0_0_30px_-8px_hsl(var(--gold)/0.5)] hover:bg-[hsl(var(--gold-bright))]",
        ghost: "hover:bg-accent/50 hover:text-foreground",
        link: "text-[hsl(var(--gold))] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-5 py-2",
        sm: "h-8 rounded-full px-3.5 text-xs",
        lg: "h-11 rounded-full px-7",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size }), (className || "").replace(/\brounded-none\b/g, ""))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
